module.exports = __webpack_public_path__ + "img/20-clown.5dd58294.svg";